import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  HOME_PAGE_ITEM_TYPE,
  HOME_PAGE_VIEWED,
  HOME_VIEW_ALL_CLICKED,
  HOME_WIDGET_ITEM_TYPE,
  HOME_WIDGET_LOADED,
} from '@core/constants/analytics';
import type { HomeViewRole } from '@app/constants/home';

export const trackHomeViewAllClicked = (
  navigationSource: string,
  count: number
) => {
  analyticsTrackEvent(HOME_VIEW_ALL_CLICKED, {
    itemType: HOME_WIDGET_ITEM_TYPE,
    navigationSource,
    count,
  });
};

export const trackHomePageViewed = (navigationSource: string) => {
  analyticsTrackEvent(HOME_PAGE_VIEWED, {
    itemType: HOME_PAGE_ITEM_TYPE,
    navigationSource,
  });
};

export const trackHomeWidgetLoaded = (
  navigationSource: string,
  count: number,
  role: HomeViewRole
) => {
  analyticsTrackEvent(HOME_WIDGET_LOADED, {
    itemType: HOME_WIDGET_ITEM_TYPE,
    navigationSource,
    count,
    // Explicit home view role — do not rely on classroom analytics context,
    // which stays stuck on the last opened space role (often educator).
    role,
  });
};
